export default "__VITE_ASSET__DRdR3oMF__"